import { render, staticRenderFns } from "./sales-order-batch-allocations.vue?vue&type=template&id=149e4f2e"
import script from "./sales-order-batch-allocations.vue?vue&type=script&lang=js"
export * from "./sales-order-batch-allocations.vue?vue&type=script&lang=js"
import style0 from "./sales-order-batch-allocations.vue?vue&type=style&index=0&id=149e4f2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports